import script from "./ActivationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivationPage.vue?vue&type=script&setup=true&lang=js"

import "./ActivationPage.vue?vue&type=style&index=0&id=4794b933&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4794b933"]])

export default __exports__